import { render } from "./ErrorBoundary.vue?vue&type=template&id=17947743&scoped=true&ts=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=ts"
export * from "./ErrorBoundary.vue?vue&type=script&lang=ts"

import "./ErrorBoundary.vue?vue&type=style&index=0&id=17947743&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17947743"]])

export default __exports__